module.exports = {
      id: "youtube-usage",
      viewBox: "0 0 15 10",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#youtube",
      toString: function () {
        return this.url;
      }
    }